import React, { type ReactElement } from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { Page } from '@tracking';

import ClusterLayout from './Layout';
import { ClusterParams } from './interfaces';

const ProCluster = ({
  clusterID,
  dollarSavings,
  proOfferCode,
  sectionData,
}: ClusterParams): ReactElement => {
  const { Track } = useEventTracking({
    contentId: clusterID,
    page: Page.ProCluster,
  });

  return (
    <Track>
      <ClusterLayout
        dollarSavings={dollarSavings}
        proOfferCode={proOfferCode}
        sectionData={sectionData}
      />
    </Track>
  );
};

export default ProCluster;
